import { IAppState } from "redux/reducers";
import { enterpriseAccountSetupActions } from "redux/actions/enterprise-account-setup";
import { commonActions } from "redux/actions/common";
import { EnterpriseAccountSetupStep } from "../../index";
import { connect } from "react-redux";
import PageTitle from "../../../../shared-ui/pageTitle";
import React, { useState } from "react";
import styles from "../../../../shard-clusters/sections/pool-name-section/pool-name-section.module.scss";
import FormSection from "../../../../shared-ui/form/form-section/form-section";
import { FormPanel } from "../../../../shared-ui/form/form-panel/form-panel";
import { BucketTable } from "../../../../buckets/bucket-table/bucket-table";
import { IBucketListItem } from "../../../../../api/entities/bucket";
import { bucketService } from "../../../../../api/services/bucket-service";
import { TableSelected } from "../../../../shared-ui/table/table";
import { TableContainer } from "./table-container";
import { accessCredentialsService } from "../../../../../api/services/application-service";
import { IAccessCredentialListItem } from "../../../../../api/entities/access-credential";
import { AccessCredentialsTable } from "components/access-credentials/access-credentials-table/access-credentials-table";
import { ShardClusterTable } from "../../../../shard-clusters/shard-cluster-table/shard-cluster-table";
import { shardClusterService } from "../../../../../api/services/shard-cluster-service";
import { IShardClusterListItem } from "../../../../../api/entities/shard-cluster";
import { ShardRepositoryTable } from "../../../../shard-repositories/shard-repository-table/shard-repository-table";
import { shardRepositoryService } from "../../../../../api/services/shard-repository-service";
import { IShardRepository } from "../../../../../api/entities/shard-repository";

const mapStateToProps = (state: IAppState) => ({
    enterpriseAccountSetupSteps: state.enterpriseAccountSetup.enterpriseAccountSetupStep,
    user: state.users.currentUser
});
const mapDispatchToProps = dispatch => {
    return {
        setStep: (step: EnterpriseAccountSetupStep) => {
            dispatch(enterpriseAccountSetupActions.setStep(step));
        },
        startLoading: () => {
            dispatch(commonActions.startLoading());
        },
        stopLoading: () => {
            dispatch(commonActions.stopLoading());
        }
    };
};

interface IOrganizationProps extends ReturnType<typeof mapDispatchToProps>,
    ReturnType<typeof mapStateToProps> {
}

function DataMigrationWizardStep(props: IOrganizationProps) {

    const [bucketSelection, setBucketSelection] = useState<TableSelected<IBucketListItem>>({});
    const [accessCredentialsSelection, setAccessCredentialsSelection] = useState<TableSelected<IAccessCredentialListItem>>({});
    const [shardClusterSelection, setShardClusterSelection] = useState<TableSelected<IShardClusterListItem>>({});
    const [shardRepositorySelection, setShardRepositorySelection] = useState<TableSelected<IShardRepository>>({});

    function goToPreviousStep() {
        props.setStep(EnterpriseAccountSetupStep.UserInvitation);
    }

    // TODO hide moreoptions
    function save() {
        console.log('selection', bucketSelection);
        // formUtils.validateAll(form).then((isValid) => {
        // if (isValid) {
//                api(accountService.changeAccountType({
//                    accountType: AccountType.Enterprise,
//                    email: props.user.email,
//                    organizationName: form.name.value
//                })).then(() => props.setStep(EnterpriseAccountSetupStep.UserInvitation));
        // }
        // });
    }

    return (
        <>
            <PageTitle title="Specify Entities for Migration To Your Enterprise Account"/>
            <FormPanel
                className={styles.root}
                okButtonText="Finish"
                okButtonClick={save}
                okButtonDisabled={false}
                cancelButtonText={"Previous"}
                cancelButtonClick={goToPreviousStep}
            >
                <FormSection testId="organization-name-section" title="Buckets" className={styles.section}>
                    <TableContainer
                        tableElement={BucketTable}
                        service={bucketService}
                        selection={bucketSelection}
                        onSelectionChanged={setBucketSelection}
                    />
                </FormSection>
                <FormSection testId="organization-name-section" title="Access Credentials" className={styles.section}>
                    <TableContainer
                        tableElement={AccessCredentialsTable}
                        service={accessCredentialsService}
                        selection={accessCredentialsSelection}
                        onSelectionChanged={setAccessCredentialsSelection}
                    />
                </FormSection>
                <FormSection testId="organization-name-section" title="Storage Pools" className={styles.section}>
                    <TableContainer
                        tableElement={ShardClusterTable}
                        service={shardClusterService}
                        selection={shardClusterSelection}
                        onSelectionChanged={setShardClusterSelection}
                    />
                </FormSection>
                <FormSection testId="organization-name-section" title="Storage Nodes" className={styles.section}>
                    <TableContainer
                        tableElement={ShardRepositoryTable}
                        service={shardRepositoryService}
                        selection={shardRepositorySelection}
                        onSelectionChanged={setShardRepositorySelection}
                    />
                </FormSection>
            </FormPanel>
        </>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(DataMigrationWizardStep);
